import { render, staticRenderFns } from "./products-manufacture-flows-table.vue?vue&type=template&id=6eebc4f4&scoped=true"
import script from "./products-manufacture-flows-table.vue?vue&type=script&lang=js"
export * from "./products-manufacture-flows-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eebc4f4",
  null
  
)

export default component.exports